import React, { ReactElement } from 'react';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { getMappedRoute } from '../../../utils/routeUtility';
import { RECONCILIATION_NESTED_ROUTE } from '../../../config/route/NestedRoutesConfig';
import './Reconciliation.less';

const ReconciliationNew = ({ match, location }: any): ReactElement => {

  const nextDefaultPage = getMappedRoute(location?.pathname, RECONCILIATION_NESTED_ROUTE()) || RECONCILIATION_NESTED_ROUTE()[0].routeName;

  return <NestedRoute
    match={match}
    defaultPage={nextDefaultPage}
    nestedNav={RECONCILIATION_NESTED_ROUTE()}
  />;
};

export default ReconciliationNew;
